import React from "react";
import styled from "styled-components";
import { SVG } from "../../config";

const LogoContainer = styled.div(({ maxWidth = 154 }) => {
  return {
    width: maxWidth,
    height: maxWidth * 0.59,
    flexShrink: 0,
  };
});

function DefaultLogo({ white, maxWidth }) {
  return (
    <LogoContainer maxWidth={maxWidth}>
      {white ? (
        <SVG.LogoWhite
          style={{
            width: "100%",
            height: "100%",
            alignSelf: "center",
          }}
        />
      ) : (
        <SVG.Logo
          style={{
            width: "100%",
            height: "100%",
            alignSelf: "center",
          }}
        />
      )}
    </LogoContainer>
  );
}

export default DefaultLogo;
